import { State } from 'flow/types/State';
import type { NoiseSuppressionEngine } from 'flow/utils/noise-suppression-utils';

export const selectIsHeadsetControlEnabled = (state: State) =>
    state.headsets.get('enabled', false);

export const areHeadsetsEnabledForCallId = (state: State, callId: string) =>
    selectIsHeadsetControlEnabled(state) &&
    (!state.headsets.has('disabledExceptForCallId') ||
        state.headsets.get('disabledExceptForCallId') === callId);

export const areHeadsetsDisabledBecauseOfMultipleCalls = (state: State) =>
    state.headsets.has('disabledExceptForCallId');

export const selectHeadsetsPreferredVideoInput = (state: State) =>
    state.headsets.get('preferredVideoInputId');

export const selectRegisteredHeadsets = (state: State) =>
    state.headsets.get('registeredHeadsets');

export const selectNoiseSuppressionEngine = (
    state: State,
): NoiseSuppressionEngine =>
    state.headsets.get('noiseSuppressionEngine', 'off');
